export const getErrorMessageFromResponse = (err) => {
  let errMsg = '';
  if (err.data) {
    errMsg = err.data
      ? err.data.errors && err.data.errors.length > 0
        ? err.data.errors[0].message
        : err.data.message
      : err.data.message;
  }
  return errMsg ? errMsg : '';
};
